import { Route, Routes, Navigate } from 'react-router-dom';
import {
  MarkedAsReadPage,
  ExchangesStatus,
  ArbitrageProfitPage,
  ServicesStatus
} from './pages';

export const ArbitrageRouter = () => {
  return (
    <Routes>
      <Route path="marked-as-read" element={<MarkedAsReadPage />} />
      <Route path="exchanges-status" element={<ExchangesStatus />} />
      <Route path="services-status" element={<ServicesStatus />} />
      <Route path="/profits" element={<ArbitrageProfitPage />} />
      <Route path="/" element={<Navigate replace to="./profits" />} />
    </Routes>
  );
};
